/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LocationListEntryFromJSON, LocationListEntryToJSON, } from './LocationListEntry';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfLocationListEntry interface.
 */
export function instanceOfPagedResponseOfLocationListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfLocationListEntryFromJSON(json) {
    return PagedResponseOfLocationListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfLocationListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(LocationListEntryFromJSON)),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious']
    };
}
export function PagedResponseOfLocationListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entries': value.entries === undefined ? undefined : (value.entries.map(LocationListEntryToJSON)),
        'hasNext': value.hasNext,
        'totalElements': value.totalElements,
        'nextPage': PageRequestToJSON(value.nextPage),
        'numberOfElements': value.numberOfElements,
        'metaData': MetaDataToJSON(value.metaData),
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size,
        'page': value.page,
        'hasPrevious': value.hasPrevious
    };
}
